var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVirtMeeting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FFB327"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_140_626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.81 15.8278L17.7102 14.3505V8.1477C17.7102 7.31912 17.0361 6.64502 16.2075 6.64502H7.79249C6.96391 6.64502 6.2898 7.31912 6.2898 8.1477V14.3505L5.19003 15.8278C4.97279 16.1196 4.93927 16.5029 5.10257 16.828C5.26585 17.1531 5.59329 17.3551 5.95708 17.3551H18.0429C18.4067 17.3551 18.7342 17.1531 18.8974 16.828C19.0607 16.5029 19.0272 16.1196 18.81 15.8278ZM7.10945 8.1477C7.10945 7.77108 7.41586 7.46467 7.79249 7.46467H16.2075C16.5842 7.46467 16.8906 7.77108 16.8906 8.1477V14.0765H7.10945V8.1477ZM18.165 16.4601C18.1509 16.4882 18.1163 16.5354 18.0429 16.5354H5.95708C5.88375 16.5354 5.84913 16.4882 5.83501 16.4601C5.82086 16.432 5.8037 16.376 5.84749 16.3172L6.90544 14.8961H17.0946L18.1525 16.3172C18.1963 16.3761 18.1791 16.432 18.165 16.4601Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1204 8.2843H10.88C10.6537 8.2843 10.4702 8.46779 10.4702 8.69412C10.4702 8.92046 10.6537 9.10395 10.88 9.10395H13.1204C13.3467 9.10395 13.5302 8.92046 13.5302 8.69412C13.5302 8.46779 13.3467 8.2843 13.1204 8.2843Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_140_626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtMeeting);
export default __webpack_public_path__ + "static/media/virtMeeting.d9964dbc4faa4e6faa9acb15b57aa8a7.svg";
export { ForwardRef as ReactComponent };